import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GRADIENT_DODGER_BLUE_CENTER, GRADIENT_DODGER_BLUE_END, GRADIENT_DODGER_BLUE_START } from '@airtel/air-design-system';
import Svg, { Circle, Defs, RadialGradient, Stop } from 'react-native-svg';
export var SocialProof = () => {
  return _jsxs(Svg, Object.assign({
    width: "30",
    height: "30",
    fill: "none"
  }, {
    children: [_jsx(Circle, {
      cx: "15",
      cy: "15",
      r: "14.857",
      fill: "url(#a)"
    }), _jsx(Defs, {
      children: _jsxs(RadialGradient, Object.assign({
        id: "a",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "matrix(33.17351 41.45622 -40.47617 32.38927 -.123 -1.055)",
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx(Stop, {
          offset: ".118",
          stopColor: GRADIENT_DODGER_BLUE_END
        }), _jsx(Stop, {
          offset: ".814",
          stopColor: GRADIENT_DODGER_BLUE_START
        }), _jsx(Stop, {
          offset: "1",
          stopColor: GRADIENT_DODGER_BLUE_CENTER
        })]
      }))
    })]
  }));
};